<template>
  <div class="walletCouponPage">
    <div class="couponField">
      <div>
        <img
          src="../../../../static/img/ic_sale.png"
          alt="sale_img"
          title="sale_img"
        />
      </div>
      <div style="display: flex; flex-direction: column">
        <input
          id="coupon_code"
          class="coupon_text"
          name="COUPON_CODE"
          v-model="customCouponCode"
          type="text"
          placeholder="Enter Coupon Code"
        />
        <p class="invalid_coupon">{{ invalidCouponMsg }}</p>
      </div>

      <button
        class="apply no-select"
        v-on:click="verifyPromoCode(customCouponCode)"
      >
        APPLY
      </button>
    </div>
    <div v-if="codeLists.length === 0" class="couponAvailability">
      <p>No Available Coupon</p>
    </div>
    <div v-else class="wallet_codes_wrapper">
      <div class="couponAvailability">
        <p>Available Coupons</p>
      </div>
      <div v-for="code in codeLists" :key="code.id" class="wallet_code">
        <div class="flex">
          <div style="color: #3cb6c3; font-weight: bold">
            {{ code.promo_str }}
          </div>
          <button
            class="apply no-select"
            :style="{ color: code.is_enable ? '#ff8080' : 'gray' }"
            v-on:click="code.is_enable ? verifyPromoCode(code.promo_str) : ''"
          >
            APPLY
          </button>
        </div>
        <div style="margin-top: 10px">
          <h5>{{ code.header }}</h5>
        </div>
        <hr />
        <div
          :class="{ 'error-margin': code.error_msg }"
          style="color: #ff8080; font-weight: bold"
        >
          {{ code.error_msg }}
        </div>
        <div
          style="color: #a9a9a9"
          v-html="formattedDescription(code.description)"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      apiDataObj: {
        default_amount: "",
      },
      customCouponCode: "",
      invalidCouponMsg: "",
      codeLists: [],
      noCouponAvailable: false,
      loading: false,
    };
  },
  mounted() {
    this.customCouponCode = document.getElementById("coupon_code").value;
    this.getCouponList();
  },
  methods: {
    formattedDescription(description) {
      return description.replace(/(?<!^)- /g, " <br>- ");
    },
    getCouponList() {
      this.loading = true;
      this.apiDataObj.default_amount = sessionStorage.getItem("rechargeAmount");
      const params = new URLSearchParams();
      params.append("user_id", sessionStorage.getItem("userId"));
      params.append("code_type", "wallet");
      params.append("recharge_amount", this.apiDataObj.default_amount);

      axios({
        url: process.env.BASE_API + "/products/offers-code-list",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      })
        .then((response) => {
          this.loading = false;
          if (response.data.status === "000000") {
            // console.log(response.data)
            this.codeLists = response.data.code_list;
          }
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    },
    verifyPromoCode(couponCode) {
      // console.log(couponCode)
      sessionStorage.setItem("couponClicked", 1);
      const params = new URLSearchParams();

      params.append("user_id", sessionStorage.getItem("userId"));
      params.append("coupon_code", couponCode);
      params.append("recharge_amount", this.apiDataObj.default_amount);
      axios({
        url: process.env.BASE_API + "/accounts/verify-wallet-coupon",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      }).then((response) => {
        // console.log(response.data)
        if (response.data.msg_type === "success") {
          sessionStorage.setItem("promoStr", couponCode);
          sessionStorage.setItem(
            "verifyWalletResponse",
            JSON.stringify(response.data)
          );
          sessionStorage.setItem("showDialog", true);
          sessionStorage.setItem("promoCodeId", response.data.promo_code_id);
          sessionStorage.setItem("promoCodeStr", response.data.promo_code_str);

          window.location.href =
            process.env.VUE_BASE_URL +
            "/a/p?" +
            sessionStorage.getItem("paymentUrl");

          //this.$router.go(-1);
        } else {
          sessionStorage.setItem("promoStr", "");
          this.invalidCouponMsg = "Invalid Coupon Code";
        }
      });
    },
  },
};
</script>
<style>
h1,
h2,
h3,
h4,
h5,
h6 {
  letter-spacing: 0px !important;
}
.error-margin {
  margin-bottom: 10px;
  font-size: 14px;
}
.walletCouponPage {
  width: 50%;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}
.button3:hover {
  cursor: pointer;
}
.wallet_codes_wrapper {
  border-radius: 2px;
  padding: 20px 10px;
}
.wallet_code {
  background-color: white;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  padding: 20px 10px;
}
.flex {
  display: flex;
  justify-content: space-between;
}
.couponField {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  background-color: white;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-top: 10px;
  width: 80%;
}
.couponField img {
  max-width: 30px;
  height: 30px;
  /* height: auto; */
}
.apply {
  color: #ff8080;
  font-weight: bold;
  outline: none;
  background-color: transparent;
  border: none;
}
.apply:focus {
  outline: none;
}
.no-select {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.apply:hover {
  cursor: pointer;
}
.couponField input {
  border: none;
  margin-left: 10px;
  color: gray;
}
.couponField p {
  margin-bottom: 0;
}
.couponAvailability {
  padding: 0px 10px 20px 10px;
}
.couponAvailability p {
  margin-bottom: 0;
  font-size: 18px;
  width: 100% !important;
  white-space: nowrap; /* Prevent text from wrapping */
  overflow: hidden; /* Hide any overflow */
  text-overflow: ellipsis; /* Add ellipsis if text overflows */
}
.invalid_coupon {
  color: #ff8080;
  font-weight: bold;
  text-align: left;
  font-size: 14px;
}
@media screen and (max-width: 800px) {
  .walletCouponPage {
    width: 70%;
  }
  .couponField {
    width: 90%;
  }
}
@media screen and (max-width: 500px) {
  .walletCouponPage {
    width: 90%;
  }
  .couponField {
    width: 100%;
  }
  .wallet_codes_wrapper {
    padding: 20px 0px;
  }

  .couponField input {
    width: 100%;
    margin-left: 0px;
  }
}
@media screen and (max-width: 355px) {
  .couponField {
    width: 100%;
    justify-content: center;
    padding: 20px 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Wc.vue